import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from '@angular/router';
import { combineLatest, Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { BusinessOwnerService } from 'src/app/acl-data/business-owner/business-owner.service';
import { ChoiceListService } from 'src/app/acl-data/choice-list/choice-list.service';
import { DocumentService } from 'src/app/acl-data/document/document.service';
import { I1FilenetServices } from 'src/app/acl-data/i1-filenet-services.service';

@Injectable({
    providedIn: 'root',
})
export class DocumentchoicesResolverService implements Resolve<any> {
    constructor(
        private choiceListService: ChoiceListService,
        private documentService: DocumentService,
        private businessOwnerService: BusinessOwnerService,
        private i1FilenetServices: I1FilenetServices
    ) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Observable<never> {
        // console.log('View resolver');

        const objectStore = route.data.parentMenu.data.id;

        const documentId = route.paramMap.get('documentID');

        const type = route.url[0].path;

        return combineLatest([
            type === 'DocumentView'
                ? this.i1FilenetServices.recordViewAudit(
                      objectStore,
                      documentId,
                      'View Properties'
                  )
                : of(''),
            type === 'DocumentPrint'
                ? this.i1FilenetServices.recordViewAudit(
                      objectStore,
                      documentId,
                      'Print Properties'
                  )
                : of(''),
            this.documentService.getByID(objectStore, documentId, true),
            this.choiceListService.getByID(
                objectStore,
                'ContractStatuses',
                undefined
            ),
            this.choiceListService.getByID(
                objectStore,
                'ACLDocumentClasses',
                undefined
            ),
            this.choiceListService.getByID(
                objectStore,
                'ContractAgreementTypes',
                undefined
            ),
            this.choiceListService.getByID(
                objectStore,
                'ContractTypes',
                undefined
            ),
            this.choiceListService.getByID(
                objectStore,
                'AlertTemplates',
                undefined
            ),
            this.choiceListService.getByID(
                objectStore,
                'ContractDeletedReason',
                null
            ),
            this.choiceListService.getByID(
                objectStore,
                'allProducts',
                'allProducts'
            ),
            this.choiceListService.getByID(
                objectStore,
                'allTerritories',
                'allTerritories'
            ),
            this.choiceListService.getByID(
                objectStore,
                'allMolecules',
                'allMolecules'
            ),
            this.businessOwnerService.getAll(),
        ]).pipe(
            map(_newData => {
                return { ...route.data };
            }),
            take(1)
        );
    }
}
